// Elements
const newQuickShopDrawer = document.querySelector(`#new-quick-shop-drawer`)


// Variables
let currentProduct = {}
let membershipPackId = ''
let membershipSellingPlanID = ''
let options = {}

let isKitGroup = false
let currentKitProducts = []

// Methods
function openNewQuickShop(e) {
	e.preventDefault()
	e.stopPropagation()

	const button = e.currentTarget

	const productId = button.getAttribute('data-product-id')
	const sectionId = button.getAttribute('data-section-id')

	isKitGroup = !!button.getAttribute('data-is-kit-group')

	currentProduct = window.globalProductObject?.find(productObject => productObject?.id === Number(productId))

	if (isKitGroup && currentProduct?.kit_products) currentKitProducts = currentProduct.kit_products

	membershipPackId = button.getAttribute('data-membership-pack-id') || currentProduct?.membership_pack_id || ''
	membershipSellingPlanID = button.getAttribute('data-membership-selling-plan-id') || currentProduct?.membership_selling_plan_id || ''

	if (currentProduct) {
		renderOptions()

		if (!isMobile()) {
			const parentElement = document.querySelector(`div.new-quick-shop-drawer-wrapper[data-section-id="${sectionId}"][data-product-id="${productId}"]`)
			if (parentElement) parentElement.append(newQuickShopDrawer)
		}

		newQuickShopDrawer.classList.add('is-open')
	} else {
		console.error('new-quick-shop.js => openNewQuickShop() => currentProduct is: ', currentProduct)
	}
}

function closeNewQuickShop(e) {
	if (e) {
		e.preventDefault()
		e.stopPropagation()
	}

	newQuickShopDrawer.classList.remove('is-open')

	optionsRemoveEventListener()
	resetVariables()
}


// Render Methods
function renderOptions() {
	const initProduct = isKitGroup
		? findObjectWithLongestArray(currentKitProducts, 'options_with_values')
		: currentProduct

	const optionsWithValues = initProduct.options_with_values
	const productOptions = newQuickShopDrawer.querySelector(`#product-options-wrapper`)

	let optionsHTML = ''

	optionsWithValues.forEach(product_option => {

		let optionsBlockHTML = `
			<div class="options-block">
				<label for="${product_option.name}" class="name-options">Select ${product_option.name}
					<span class="selected-option" data-selected-postion="${product_option.position}"></span>
				</label>
				
				<div class="options option-count-${product_option.values?.length}">
				
					${product_option.values?.map(value => {
						return `
							<div class="option">
								<input
									id="option-${product_option.name.replace(/\s+/g, '-').toLowerCase()}-${value.replace(`"`, '').toLowerCase()}-quick-shop"
									class="input-option"
									autocomplete="off"
									data-option-position="${product_option.position}"
									type="radio"
									name="${product_option.name.toLowerCase()}-quick-shop"
									value="${value}"
								>
					
								<label class="label-option" for="option-${product_option.name.replace(/\s+/g, '-').toLowerCase()}-${value.replace(`"`, '').toLowerCase()}-quick-shop">${sizeSimplify(value)}</label>
							</div>
						`
					}).join('')}
					
				</div>
			</div>
		`

		optionsHTML = `${optionsHTML}${optionsBlockHTML}`
	})

	productOptions.innerHTML = optionsHTML

	optionsAddEventListener()
	checkSoldout()
}

function optionsAddEventListener() {
	newQuickShopDrawer.querySelectorAll(`.input-option`)?.forEach(option => {
		option.addEventListener('change', e => setOption(e.currentTarget));
	})
}

function optionsRemoveEventListener(optionsEl) {
	newQuickShopDrawer.querySelectorAll(`.input-option`)?.forEach(option => {
		option.removeEventListener('change', setOption, false)
	})
}

function setOption(currentTarget) {
	const value = currentTarget.value
	const position = currentTarget.getAttribute('data-option-position')

	const selectedSpan = newQuickShopDrawer.querySelector(`span[data-selected-postion="${position}"]`)
	if (selectedSpan) selectedSpan.innerText = value

	options[`option${position}`] = value

	checkSoldout()
	checkSelectedAllOptions()
}

function checkSoldout() {
	document.querySelectorAll('#new-quick-shop-drawer .input-option')?.forEach(option => {
		const initOptions = { ...options }

		const value = option.value
		const position = option.getAttribute('data-option-position')

		initOptions[`option${position}`] = value

		const variantsFiltered = isKitGroup
			? productGroupVariantsHandler(initOptions, currentKitProducts, 'filter')
			: productVariantsHandler(initOptions, currentProduct, 'filter')

		if (variantsFiltered) {
			let available = true

			if (isKitGroup) {
				variantsFiltered.forEach(v => {
					if (v.length && !v.some(e => e.available)) available = false
				})
			} else available = variantsFiltered.some(e => e.available)

			if (available) {
				option.parentElement.classList.remove('soldout')
				option.parentElement.classList.add('available')
			} else {
				option.parentElement.classList.remove('available')
				option.parentElement.classList.add('soldout')
			}
		}
	})
}

function checkSelectedAllOptions() {
	const optionsBlockEls = document.querySelectorAll(`#product-options-wrapper .options-block`)
	const inputOptionCheckedEls = document.querySelectorAll(`#product-options-wrapper .input-option:checked`)

	if ( optionsBlockEls.length === inputOptionCheckedEls.length) handleNewQuickShopAddToCart()
}

function productVariantsHandler(initOptions, product = {}, method) {
	const variants = product.variants

	if (!initOptions || !variants) return false

	return variants[method](variant => {
		// checking for out of stock when if first option is not selected
		const optionsKeys = Object.keys(initOptions)
		const productOptionsLength = product.options?.length || Number(product.option_size) || 0

		if ((optionsKeys.length === 1 || productOptionsLength === 1) && !product.kit_group) {
			const optionKey = optionsKeys[0]
			return variant[optionKey]?.replace('\"', '') === initOptions[optionKey]
		}

		return compareOptions(initOptions, variant)
	})
}

function productGroupVariantsHandler(initOptions, products = [], method) {
	let fullVar = []

	products.forEach(product => {
		fullVar.push(product.variants[method](variant => compareOptions(initOptions, variant)))
	})

	return fullVar
}

function compareOptions(initOptions, variant) {
	if (isKitGroup) {
		const initVariantOptions = variant.options

		initVariantOptions.forEach((v, index) => initVariantOptions[index] = handleVariant(v))

		const existOptions = []

		if (initVariantOptions.includes(initOptions['option1'])) existOptions.push(true)
		if (initVariantOptions.includes(initOptions['option2'])) existOptions.push(true)
		if (initVariantOptions.includes(initOptions['option3'])) existOptions.push(true)

		return existOptions.length === initVariantOptions.length
	}

	let result = false

	if (initOptions['option1']) {
		result = variant.option1?.replace('\"', '') === initOptions['option1']
	}

	if (initOptions['option1'] && initOptions['option2']) {
		result = variant.option1?.replace('\"', '') === initOptions['option1'] && variant.option2?.replace('\"', '') === initOptions['option2']
	}

	if (initOptions['option1'] && initOptions['option2'] && initOptions['option3']) {
		result = variant.option1?.replace('\"', '') === initOptions['option1'] && variant.option2?.replace('\"', '') === initOptions['option2'] && variant.option3?.replace('\"', '') === initOptions['option3']
	}

	return result
}

function handleNewQuickShopAddToCart() {
	if (isKitGroup) {

		let kitProducts = []

		currentKitProducts.forEach(kitProduct => {
			const variant = productVariantsHandler(options, kitProduct, 'find')
			if (variant) kitProducts.push({ id: variant.id, quantity: 1 })
		})

		if (membershipPackId && membershipSellingPlanID) {
			kitProducts.push({ id: membershipPackId, selling_plan: membershipSellingPlanID, quantity: 1 })
		}

		bundleAddtocart(kitProducts) // custom.js method

	} else {

		const qtyVal = 1
		const variant = productVariantsHandler(options, currentProduct, 'find')

		if (variant) {
			addtocart(variant.id, qtyVal, membershipPackId, '', true, membershipSellingPlanID) // custom.js method
		}

	}

	closeNewQuickShop()
}

function handleVariant(variant) {
	return variant?.replace('\"', '')
}

function resetVariables() {
	currentProduct = {}
	options = {}
	currentKitProducts = []
	isKitGroup = false
}

function isMobile() {
	return window.innerWidth < 491
}

function sizeSimplify(size = '') {
	if (!size) return

	const initSize = size.toLowerCase()

	switch (true) {
		case initSize === 'xsmall':
			return 'XS'

		case initSize === 'small':
			return 'S'

		case initSize === "medium":
			return 'M'

		case initSize === 'large':
			return 'L'

		case initSize === "xlarge":
			return 'XL'

		case initSize === "2xlarge":
			return '2XL'

		case initSize === "3xlarge":
			return '3XL'

		case initSize === "4xlarge":
			return '4XL'

		case initSize === "5xlarge":
			return '5XL'

		default:
			return size
	}
}

function findObjectWithLongestArray(objects, key) {
	return objects.reduce((maxObj, currentObj) => {
		return (Array.isArray(currentObj[key]) && currentObj[key].length > (maxObj[key]?.length || 0))
			? currentObj
			: maxObj;
	}, {});
}
